import styled from 'styled-components';
import {
  DialogTitle as MuiDialogTitle,
  IconButton as MuiIconButton,
  Typography as MuiTypography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

const DialogTitle = styled((props) => {
  const {
    children,
    classes,
    onClose,
    isFormDialog,
    titleButton,
    disabled,
    headerPadding,
    ...other
  } = props;

  return (
    <MuiDialogTitle disableTypography {...other}>
      {titleButton && <div className="titleButton">{titleButton}</div>}
      <MuiTypography component="span" variant="h4" align="center">
        {children}
      </MuiTypography>
      {onClose ? (
        <MuiIconButton
          size="small"
          aria-label="close"
          onClick={onClose}
          disabled={disabled}
        >
          <CloseIcon classes={{ root: 'icon' }} />
        </MuiIconButton>
      ) : null}
    </MuiDialogTitle>
  );
})`
  padding: ${(props) => props.headerPadding || '28px 24px 0'};
  min-width: 350px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  .titleButton {
    min-width: 32px;
  }
  .closeButton {
    font-size: 10px;
    color: ${(props) => props.theme.palette.grey[900]};
    border: 1px solid ${(props) => props.theme.palette.grey[200]};
    border-radius: 5px;

    height: 32px;
    width: 32px;
  }
  .icon {
    font-size: 16px;
  }
`;

export default DialogTitle;
